import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { VerificationsClient } from '@/components/admin/verifications-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/verifications')({
  component: VerificationsPage,
});

function VerificationsPage(): React.ReactElement {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader
        title="Vérifications prestataires"
        subtitle="Profils prestataires en attente de vérification manuelle."
      />
      <VerificationsClient />
    </div>
  );
}
